import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f9a889cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invite" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "将生成的链接发给观众进行授权观看，也可将生成 的二维码图片发送给观众微信扫码进行授权观看。", -1))
const _hoisted_3 = {
  id: "qrcode",
  class: "invite_code"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "下载的格式为Excal表格。", -1))
const _hoisted_6 = { class: "invite_scroll" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "worp_swt" }

import { computed, getCurrentInstance, ref } from 'vue';
import { message, Input, Popover, Modal, Table, InputNumber, notification } from 'ant-design-vue';
import ClipboardJS from 'clipboard';
import { useStore } from 'vuex';
import http from '@/api/live';
import router from '@/router';
import { useDebounce } from '@/hooks/useDebounce';
import { getToken } from '@/plugins/cookie';
import { QuestionCircleFilled } from '@ant-design/icons-vue';
import { useQRCode } from '@vueuse/integrations/useQRCode';
import { onExport } from '@/components/CExport'; //导出
import https from '@/api/exportList';

// `qrcode` will be a ref of data URL
interface Item {
  key: number;
  id: number;
  nameId: number;
  nameImg: string;
  name: string;
  url: string;
  bornTime: string;
  bindTime: string;
}

//  授权观看  -----邀约观看
const __default__ = { name: 'InviteWatch' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const liveBroadcastingRoomId = router.currentRoute.value.params.studioId;
// console.log('id', liveBroadcastingRoomId);
const aInput = Input;
const aPopover = Popover;
const aModal = Modal;
const aTable = Table;
const aInputNumber = InputNumber;
const title1 = ref<number>(0);
// const checked = ref<boolean>(false);
const visible = ref<boolean>(false);
const store = useStore();
const form = computed(() => store.state.authorizView.inviteView);
const updateForm = (type: number) => {
  if (form.value.viewSwitch) {
    message.destroy();
    store.commit('authorizView/updateChildSwitch');
    if (!type) store.commit('authorizView/checkInviteSwitch');
  }
  store.commit('authorizView/updateInviteForm', form.value);
};
const showModal = () => {
  visible.value = true;
  inviteList();
};
const handleOk = (e: MouseEvent) => {
  // console.log(e);
  visible.value = false;
};

const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    width: '100px',
    align: 'center',
  },
  {
    title: '用户ID',
    dataIndex: 'uid',
    width: '100px',
    align: 'center',
  },
  {
    title: '用户头像',
    dataIndex: 'avatar_url',
    align: 'center',
    slots: { customRender: 'nameImg' },
  },
  {
    title: '用户名',
    dataIndex: 'name',
    width: '110px',
    align: 'center',
    slots: { customRender: 'name' },
  },
  {
    title: '邀约地址',
    dataIndex: 'url',
    width: '180px',
    align: 'center',
    ellipsis: true,
  },
  {
    title: '生成时间',
    dataIndex: 'created_at',
    width: '180px',
    align: 'center',
  },
  {
    title: '绑定时间',
    dataIndex: 'updated_at',
    width: '180px',
    align: 'center',
  },
];
const showLoading = ref<boolean>(false);
const list = ref<Item[]>([]);
const lastPage = ref();
const perPage = ref('');
const total = ref();
const inviteList = () => {
  const data = {
    studio_id: liveBroadcastingRoomId,
  };
  showLoading.value = true;
  http
    .getBindList({ params: data })
    .then((res) => {
      list.value = res.data.data.data;
      lastPage.value = res.data.data.last_page;
      perPage.value = res.data.data.per_page;
      total.value = res.data.data.total;
      showLoading.value = false;
    })
    .catch((err) => {
      showLoading.value = false;
    });
};

const address = ref({
  url: '',
});
const createAddress = useDebounce(() => {
  const data = {
    studio_id: liveBroadcastingRoomId,
    number: 1,
  };
  http.createCode(data).then((res) => {
    address.value = res.data.data.items[0];
    qrSrc.value = address.value.url;
  });
});
createAddress();
const batchcreateUrl = useDebounce((title1: number) => {
  const data = {
    studio_id: liveBroadcastingRoomId,
    number: title1,
  };
  http.createCode(data).then((res) => {
    window.location.href = res.data.data.export_url;
    title1 = 0;
  });
});
// 生成二维码
const qrcode = () => {
  createAddress();
};
// 复制
const Copylist = (btns: string) => {
  let ClipboardJSObj = new ClipboardJS(btns);
  // // let ClipboardJSObj2 = new ClipboardJS('.text_btns');
  ClipboardJSObj.on('success', function (e) {
    message.destroy();
    message.info('复制成功');
    e.clearSelection();
  });
  ClipboardJSObj.on('error', function () {
    message.destroy();
    message.info('复制失败');
  });
};
// 导出数据
const { proxy }: any = getCurrentInstance();
const token = getToken();
const corn = ref(1);
const messageTip = ref();
const ExportTemplate = useDebounce(() => {
  const data = {
    studio_id: liveBroadcastingRoomId,
    type: 10,
    is_cron_download: corn.value,
  };
  https
    .excel_regional_distribution({ params: data })
    .then((res: any) => {
      messageTip.value = res.data.message;
      openNotificationWithIcon('success');
    })
    .catch((res: any) => {
      messageTip.value = res.data.error
      openNotificationWithIcon('error');
    });
});
// 导出成功时发出通知
const openNotificationWithIcon = (type: string) => {
  notification[type]({
    message: messageTip.value,
   duration: 5,
  });
};

const qrSrc = ref();
const qrcodeUrl = useQRCode(qrSrc, {
  margin: 0,
});

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_switch = _resolveComponent("a-switch")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createTextVNode(" 单个生成："),
      _createVNode(_unref(aInput), {
        value: address.value.url,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((address.value.url) = $event)),
        class: "invite_on",
        id: "warrants",
        onInput: _cache[1] || (_cache[1] = ($event: any) => (updateForm(1)))
      }, null, 8, ["value"]),
      _createVNode(_component_a_button, {
        type: "link",
        class: "but_text but_color",
        onClick: qrcode
      }, {
        default: _withCtx(() => [
          _createTextVNode("生成")
        ]),
        _: 1
      }),
      _createVNode(_component_a_button, {
        type: "link",
        class: "pledge but_color",
        "data-clipboard-text": address.value.url,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (Copylist('.pledge')))
      }, {
        default: _withCtx(() => [
          _createTextVNode("复制")
        ]),
        _: 1
      }, 8, ["data-clipboard-text"]),
      _createVNode(_unref(aPopover), {
        placement: "right",
        class: "invite_but"
      }, {
        content: _withCtx(() => [
          _hoisted_2
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(QuestionCircleFilled), { class: "QuestionCircleFilled" })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        (_unref(qrcodeUrl))
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _unref(qrcodeUrl),
              alt: "QR Code"
            }, null, 8, _hoisted_4))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _createTextVNode(" 批量生成："),
        _createVNode(_unref(aInputNumber), {
          id: "inputNumber",
          min: 0,
          max: 500,
          step: 1,
          value: title1.value,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((title1).value = $event)),
          class: "invite_down"
        }, null, 8, ["value"]),
        _createTextVNode("个 "),
        _createVNode(_component_a_button, {
          type: "link",
          class: "but_text but_color",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(batchcreateUrl)(title1.value)))
        }, {
          default: _withCtx(() => [
            _createTextVNode("生成并下载")
          ]),
          _: 1
        }),
        _createVNode(_unref(aPopover), {
          placement: "right",
          class: "invite_but"
        }, {
          content: _withCtx(() => [
            _hoisted_5
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(QuestionCircleFilled), { class: "QuestionCircleFilled" })
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_a_button, {
        type: "link",
        class: "invite_but1",
        onClick: showModal
      }, {
        default: _withCtx(() => [
          _createTextVNode("使用记录")
        ]),
        _: 1
      }),
      _createVNode(_unref(aModal), {
        visible: visible.value,
        "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((visible).value = $event)),
        title: "使用记录",
        rowKey: "id",
        width: "1012px",
        cancelText: " ",
        okText: " ",
        centered: "",
        onOk: handleOk
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_a_button, {
            class: "mod_modal_btn mod_type_primary",
            onClick: _unref(ExportTemplate)
          }, {
            default: _withCtx(() => [
              _createTextVNode("导出")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_unref(aTable), {
              loading: showLoading.value,
              columns: columns,
              "data-source": list.value,
              pagination: false,
              rowKey: "id"
            }, {
              name: _withCtx(({ record }) => [
                (record.name === '')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, "未使用"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(record.name), 1))
              ]),
              nameImg: _withCtx(({ record }) => [
                _createVNode(_component_a_button, {
                  type: "link",
                  class: "invite_img"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: record.avatar_url,
                      class: "invite_img_center"
                    }, null, 8, _hoisted_9)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            }, 8, ["loading", "data-source"])
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createTextVNode(" 功能开关： "),
      _createVNode(_component_a_switch, {
        checked: _unref(form).viewSwitch,
        "onUpdate:checked": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).viewSwitch) = $event)),
        onChange: _cache[7] || (_cache[7] = ($event: any) => (updateForm(0)))
      }, null, 8, ["checked"])
    ])
  ], 64))
}
}

})